import axios from "axios";

const usersInstance = axios.create({
  baseURL: `http://3.113.123.43:5000`,
});

export const getUsersListEffect = (token) => {
  return usersInstance.request({
    url: "/admin/userList?pageNo=1&pagesize=20&pagination_required=false",
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const deleteUsersListEffect = (data, token) => {
  return usersInstance.request({
    url: `/admin/userDelete/${data}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getUserUpdateListEffect = (data, token) => {
  const orgId = localStorage.getItem("org_id");
  return usersInstance.request({
    url: `/user/details/${data}?organization_id=${orgId}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
